var _filter, _clipPath, _use;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawAddNotesReLn36(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1.005em",
    height: "1em",
    viewBox: "0 0 364 363",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 364,
    height: 363,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.2,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 364,
    height: 363
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 29.136719 205.007812 L 29.550781 180.308594 L 42.617188 154.007812 L 32.132812 181.007812 Z M 29.136719 205.007812 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 240.015625 96.074219 L 180.289062 96.074219 C 177.640625 96.082031 175.136719 94.863281 173.5 92.777344 C 171.835938 90.671875 171.234375 87.914062 171.871094 85.300781 C 177.375 62.214844 177.375 38.152344 171.871094 15.066406 C 171.234375 12.457031 171.835938 9.699219 173.5 7.589844 C 175.136719 5.503906 177.640625 4.289062 180.289062 4.296875 L 240.015625 4.296875 C 244.273438 4.308594 247.898438 7.402344 248.582031 11.613281 C 252.511719 37.175781 252.511719 63.191406 248.582031 88.757812 C 247.898438 92.964844 244.273438 96.0625 240.015625 96.074219 Z M 240.015625 96.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 180.289062 8.796875 C 179.019531 8.792969 177.816406 9.375 177.027344 10.378906 C 176.21875 11.402344 175.929688 12.746094 176.238281 14.015625 C 181.910156 37.792969 181.910156 62.574219 176.238281 86.351562 C 175.929688 87.621094 176.21875 88.964844 177.027344 89.992188 C 177.816406 90.992188 179.019531 91.578125 180.289062 91.574219 L 240.015625 91.574219 C 242.058594 91.574219 243.804688 90.09375 244.140625 88.074219 C 248 62.960938 248 37.40625 244.140625 12.296875 C 243.804688 10.277344 242.058594 8.796875 240.015625 8.796875 Z M 180.289062 8.796875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 226.980469 30.433594 L 195.640625 30.433594 C 193.160156 30.429688 191.148438 28.417969 191.148438 25.933594 L 191.148438 24.175781 C 191.148438 21.691406 193.160156 19.679688 195.640625 19.675781 L 226.980469 19.675781 C 229.460938 19.679688 231.472656 21.691406 231.476562 24.175781 L 231.476562 25.933594 C 231.472656 28.417969 229.460938 30.429688 226.980469 30.433594 Z M 226.980469 30.433594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 226.980469 52.652344 L 195.640625 52.652344 C 193.160156 52.652344 191.148438 50.636719 191.148438 48.152344 L 191.148438 46.394531 C 191.148438 43.910156 193.160156 41.898438 195.640625 41.894531 L 226.980469 41.894531 C 229.460938 41.898438 231.472656 43.910156 231.476562 46.394531 L 231.476562 48.152344 C 231.472656 50.636719 229.460938 52.652344 226.980469 52.652344 Z M 226.980469 52.652344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 226.980469 74.871094 L 195.640625 74.871094 C 193.160156 74.871094 191.148438 72.855469 191.148438 70.371094 L 191.148438 68.613281 C 191.148438 66.128906 193.160156 64.117188 195.640625 64.113281 L 226.980469 64.113281 C 229.460938 64.117188 231.472656 66.128906 231.476562 68.613281 L 231.476562 70.371094 C 231.472656 72.855469 229.460938 74.871094 226.980469 74.871094 Z M 226.980469 74.871094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 352.359375 153.074219 L 292.636719 153.074219 C 289.988281 153.082031 287.480469 151.863281 285.847656 149.777344 C 284.179688 147.671875 283.578125 144.914062 284.214844 142.300781 C 289.71875 119.214844 289.71875 95.152344 284.214844 72.066406 C 283.578125 69.457031 284.179688 66.699219 285.847656 64.589844 C 287.480469 62.503906 289.988281 61.289062 292.636719 61.296875 L 352.359375 61.296875 C 356.617188 61.308594 360.242188 64.402344 360.925781 68.613281 C 364.859375 94.175781 364.859375 120.191406 360.925781 145.757812 C 360.242188 149.964844 356.617188 153.0625 352.359375 153.074219 Z M 352.359375 153.074219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 292.636719 65.796875 C 291.363281 65.792969 290.160156 66.375 289.375 67.378906 C 288.566406 68.402344 288.273438 69.746094 288.585938 71.015625 C 294.253906 94.792969 294.253906 119.574219 288.585938 143.351562 C 288.273438 144.621094 288.566406 145.964844 289.375 146.992188 C 290.160156 147.992188 291.363281 148.578125 292.636719 148.574219 L 352.359375 148.574219 C 354.40625 148.574219 356.152344 147.09375 356.484375 145.074219 C 360.347656 119.960938 360.347656 94.40625 356.484375 69.296875 C 356.152344 67.277344 354.40625 65.796875 352.359375 65.796875 Z M 292.636719 65.796875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(94.901961%,94.901961%,94.901961%)",
      fillOpacity: 1
    },
    d: "M 233.273438 217.949219 L 173.550781 217.949219 C 170.785156 217.957031 168.171875 216.6875 166.464844 214.511719 C 164.730469 212.3125 164.101562 209.4375 164.765625 206.714844 C 170.257812 183.683594 170.257812 159.683594 164.765625 136.652344 C 164.101562 133.933594 164.730469 131.054688 166.464844 128.859375 C 168.171875 126.679688 170.785156 125.414062 173.550781 125.421875 L 233.273438 125.421875 C 237.714844 125.433594 241.496094 128.664062 242.210938 133.054688 C 246.148438 158.65625 246.148438 184.710938 242.210938 210.3125 C 241.496094 214.703125 237.714844 217.933594 233.273438 217.949219 Z M 233.273438 217.949219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 339.328125 98.683594 L 307.984375 98.683594 C 305.503906 98.679688 303.496094 96.667969 303.492188 94.183594 L 303.492188 92.425781 C 303.496094 89.941406 305.503906 87.929688 307.984375 87.925781 L 339.328125 87.925781 C 341.808594 87.929688 343.816406 89.941406 343.820312 92.425781 L 343.820312 94.183594 C 343.816406 96.667969 341.808594 98.679688 339.328125 98.683594 Z M 339.328125 98.683594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 339.328125 120.902344 L 307.984375 120.902344 C 305.503906 120.902344 303.496094 118.886719 303.492188 116.402344 L 303.492188 114.644531 C 303.496094 112.160156 305.503906 110.148438 307.984375 110.144531 L 339.328125 110.144531 C 341.808594 110.148438 343.816406 112.160156 343.820312 114.644531 L 343.820312 116.402344 C 343.816406 118.886719 341.808594 120.902344 339.328125 120.902344 Z M 339.328125 120.902344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 220.804688 171.375 C 220.804688 180.902344 213.09375 188.625 203.578125 188.625 C 194.066406 188.625 186.351562 180.902344 186.351562 171.375 C 186.351562 161.847656 194.066406 154.125 203.578125 154.125 C 213.09375 154.125 220.804688 161.847656 220.804688 171.375 Z M 220.804688 171.375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 211.816406 169.125 L 205.824219 169.125 L 205.824219 163.125 C 205.824219 161.882812 204.820312 160.875 203.578125 160.875 C 202.335938 160.875 201.332031 161.882812 201.332031 163.125 L 201.332031 169.125 L 195.339844 169.125 C 194.097656 169.125 193.09375 170.132812 193.09375 171.375 C 193.09375 172.617188 194.097656 173.625 195.339844 173.625 L 201.332031 173.625 L 201.332031 179.625 C 201.332031 180.867188 202.335938 181.875 203.578125 181.875 C 204.820312 181.875 205.824219 180.867188 205.824219 179.625 L 205.824219 173.625 L 211.816406 173.625 C 213.058594 173.625 214.0625 172.617188 214.0625 171.375 C 214.0625 170.132812 213.058594 169.125 211.816406 169.125 Z M 211.816406 169.125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(80%,80%,80%)",
      fillOpacity: 1
    },
    d: "M 225.296875 12.75 L 193.84375 12.75 C 191.980469 12.746094 190.472656 11.238281 190.472656 9.375 L 190.472656 3.375 C 190.472656 1.511719 191.980469 0.00390625 193.84375 0 L 225.296875 0 C 227.160156 0.00390625 228.667969 1.511719 228.667969 3.375 L 228.667969 9.375 C 228.667969 11.238281 227.160156 12.746094 225.296875 12.75 Z M 225.296875 12.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(80%,80%,80%)",
      fillOpacity: 1
    },
    d: "M 339.140625 70.5 L 307.6875 70.5 C 305.824219 70.496094 304.316406 68.988281 304.316406 67.125 L 304.316406 61.125 C 304.316406 59.261719 305.824219 57.753906 307.6875 57.75 L 339.140625 57.75 C 341.003906 57.753906 342.511719 59.261719 342.511719 61.125 L 342.511719 67.125 C 342.511719 68.988281 341.003906 70.496094 339.140625 70.5 Z M 339.140625 70.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,72.156863%,72.156863%)",
      fillOpacity: 1
    },
    d: "M 66.355469 353.296875 L 75.539062 353.296875 L 78.410156 317.828125 L 66.355469 317.828125 Z M 66.355469 353.296875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.431373%,18.039216%,25.490196%)",
      fillOpacity: 1
    },
    d: "M 64.015625 350.292969 L 82.097656 350.292969 C 88.460938 350.292969 93.621094 355.460938 93.621094 361.832031 L 93.621094 362.207031 L 64.015625 362.207031 Z M 64.015625 350.292969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,72.156863%,72.156863%)",
      fillOpacity: 1
    },
    d: "M 16.921875 353.296875 L 26.105469 353.296875 L 30.476562 317.828125 L 16.921875 317.828125 Z M 16.921875 353.296875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.431373%,18.039216%,25.490196%)",
      fillOpacity: 1
    },
    d: "M 14.582031 350.292969 L 32.664062 350.292969 C 39.03125 350.292969 44.191406 355.460938 44.191406 361.832031 L 44.191406 362.207031 L 14.582031 362.207031 Z M 14.582031 350.292969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.431373%,18.039216%,25.490196%)",
      fillOpacity: 1
    },
    d: "M 18.554688 342.09375 C 17.617188 342.089844 16.714844 341.738281 16.023438 341.101562 C 15.277344 340.421875 14.839844 339.460938 14.816406 338.449219 L 11.132812 206.289062 L 63.417969 219.378906 L 79.550781 267.84375 C 81.632812 274.078125 82.53125 280.644531 82.207031 287.210938 L 80.203125 334.1875 C 80.109375 336.1875 78.460938 337.757812 76.464844 337.757812 L 67.695312 337.757812 C 65.820312 337.75 64.242188 336.367188 63.984375 334.511719 L 57.714844 282.652344 C 57.167969 278.609375 55.753906 274.730469 53.570312 271.28125 L 41.234375 251.722656 C 41.066406 251.457031 40.75 251.324219 40.441406 251.394531 C 40.132812 251.460938 39.898438 251.71875 39.859375 252.03125 L 30.179688 338.347656 C 29.964844 340.15625 28.484375 341.546875 26.667969 341.644531 L 18.765625 342.085938 C 18.695312 342.089844 18.625 342.09375 18.554688 342.09375 Z M 18.554688 342.09375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,72.156863%,72.156863%)",
      fillOpacity: 1
    },
    d: "M 73.113281 102.304688 C 73.113281 112.476562 64.878906 120.726562 54.71875 120.726562 C 44.558594 120.726562 36.324219 112.476562 36.324219 102.304688 C 36.324219 92.132812 44.558594 83.882812 54.71875 83.882812 C 64.878906 83.882812 73.113281 92.132812 73.113281 102.304688 Z M 73.113281 102.304688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(35.686275%,80.784314%,86.666667%)",
      fillOpacity: 1
    },
    d: "M 63.167969 224.753906 C 62.851562 224.753906 62.535156 224.714844 62.230469 224.636719 L 10.351562 211.316406 C 8.425781 210.820312 7.222656 208.90625 7.609375 206.953125 L 19.523438 142.683594 C 21.03125 135.144531 26.140625 128.824219 33.191406 125.78125 C 40.066406 122.734375 48.003906 123.316406 54.363281 127.335938 C 55.089844 127.789062 55.820312 128.285156 56.535156 128.808594 C 62.378906 133.125 65.867188 139.933594 65.957031 147.203125 L 66.90625 220.949219 C 66.917969 221.953125 66.53125 222.917969 65.828125 223.632812 C 65.125 224.347656 64.167969 224.75 63.167969 224.753906 Z M 63.167969 224.753906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,72.156863%,72.156863%)",
      fillOpacity: 1
    },
    d: "M 15.691406 225.511719 C 14.4375 223.664062 14.066406 221.355469 14.675781 219.210938 C 15.285156 217.0625 16.8125 215.296875 18.847656 214.386719 L 16.539062 187.683594 L 28.765625 194.320312 L 29.082031 218.660156 C 30.414062 222.261719 28.84375 226.292969 25.425781 228.042969 C 22.007812 229.789062 17.828125 228.703125 15.691406 225.511719 Z M 15.691406 225.511719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(35.686275%,80.784314%,86.666667%)",
      fillOpacity: 1
    },
    d: "M 20.058594 210.855469 C 19.714844 210.855469 19.371094 210.808594 19.035156 210.726562 C 17.570312 210.351562 16.429688 209.203125 16.0625 207.734375 L 10.050781 183.820312 C 7.953125 175.46875 8.953125 166.640625 12.867188 158.972656 L 25.457031 134.308594 C 27.113281 128.167969 33.382812 124.488281 39.546875 126.046875 C 42.527344 126.800781 45.082031 128.71875 46.640625 131.371094 C 48.234375 134.0625 48.679688 137.28125 47.878906 140.304688 L 29.960938 180.433594 L 30.171875 204.460938 C 30.183594 206.199219 29.113281 207.757812 27.488281 208.367188 L 21.492188 210.597656 C 21.03125 210.765625 20.546875 210.855469 20.058594 210.855469 Z M 20.058594 210.855469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,72.156863%,72.156863%)",
      fillOpacity: 1
    },
    d: "M 105.84375 215.6875 C 103.628906 215.433594 101.640625 214.210938 100.410156 212.347656 C 99.183594 210.488281 98.84375 208.175781 99.480469 206.035156 L 77.765625 190.371094 L 90.765625 185.417969 L 109.394531 201.054688 C 112.988281 202.394531 115.015625 206.21875 114.109375 209.953125 C 113.203125 213.683594 109.652344 216.148438 105.84375 215.6875 Z M 105.84375 215.6875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(35.686275%,80.784314%,86.666667%)",
      fillOpacity: 1
    },
    d: "M 94.476562 204.246094 C 93.835938 204.246094 93.203125 204.097656 92.628906 203.8125 L 70.613281 192.773438 C 62.921875 188.917969 56.890625 182.398438 53.640625 174.425781 L 43.1875 148.78125 C 39.617188 143.515625 40.921875 136.359375 46.121094 132.699219 C 48.640625 130.921875 51.769531 130.234375 54.800781 130.792969 C 57.867188 131.34375 60.585938 133.101562 62.351562 135.675781 L 81.035156 175.453125 L 99.359375 190.96875 C 100.679688 192.089844 101.160156 193.921875 100.5625 195.550781 L 98.335938 201.558594 C 98.046875 202.34375 97.523438 203.023438 96.835938 203.503906 C 96.144531 203.988281 95.320312 204.246094 94.476562 204.246094 Z M 94.476562 204.246094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(18.431373%,18.039216%,25.490196%)",
      fillOpacity: 1
    },
    d: "M 50.855469 121.007812 C 51.832031 121.4375 53.835938 113.636719 52.9375 112.078125 C 51.605469 109.757812 51.683594 109.773438 50.796875 108.238281 C 49.914062 106.703125 49.714844 104.605469 50.859375 103.253906 C 52.007812 101.902344 54.660156 102.082031 55.183594 103.777344 C 54.847656 100.558594 58.023438 97.972656 61.167969 97.25 C 64.316406 96.523438 67.636719 96.972656 70.796875 96.328125 C 74.46875 95.574219 78.289062 92.492188 76.824219 88.449219 C 76.574219 87.777344 76.199219 87.15625 75.714844 86.625 C 74.023438 84.71875 71.65625 83.90625 69.339844 83.117188 C 64.523438 81.480469 59.578125 79.824219 54.496094 80.003906 C 45.9375 80.453125 38.457031 85.933594 35.4375 93.960938 C 35.085938 94.945312 34.816406 95.953125 34.625 96.980469 C 32.878906 106.375 38.328125 115.640625 47.175781 119.214844 Z M 50.855469 121.007812 "
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(90.196078%,90.196078%,90.196078%)",
      fillOpacity: 1
    },
    d: "M 147.605469 266.988281 L 92.453125 244.039062 C 90.003906 243.03125 88.15625 240.945312 87.445312 238.386719 C 86.714844 235.804688 87.214844 233.023438 88.804688 230.859375 C 102.734375 211.652344 111.953125 189.433594 115.714844 166 C 116.128906 163.34375 117.738281 161.027344 120.085938 159.722656 C 122.394531 158.421875 125.171875 158.261719 127.617188 159.289062 L 182.769531 182.234375 C 186.699219 183.882812 188.859375 188.132812 187.878906 192.28125 C 181.714844 217.398438 171.746094 241.425781 158.320312 263.523438 C 156.074219 267.144531 151.542969 268.613281 147.605469 266.988281 Z M 147.605469 266.988281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 125.894531 163.441406 C 124.71875 162.949219 123.386719 163.027344 122.273438 163.648438 C 121.132812 164.289062 120.351562 165.417969 120.152344 166.707031 C 116.277344 190.84375 106.78125 213.726562 92.4375 233.507812 C 91.664062 234.558594 91.417969 235.910156 91.769531 237.171875 C 92.113281 238.398438 93 239.398438 94.175781 239.882812 L 149.328125 262.832031 C 151.21875 263.617188 153.398438 262.921875 154.480469 261.183594 C 167.667969 239.476562 177.457031 215.878906 183.515625 191.207031 C 183.980469 189.214844 182.933594 187.175781 181.046875 186.390625 Z M 125.894531 163.441406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(35.686275%,80.784314%,86.666667%)",
      fillOpacity: 1
    },
    d: "M 155.257812 214.523438 L 126.316406 202.480469 C 124.027344 201.527344 122.941406 198.894531 123.890625 196.601562 L 124.566406 194.976562 C 125.519531 192.683594 128.148438 191.597656 130.441406 192.546875 L 159.382812 204.589844 C 161.671875 205.542969 162.757812 208.175781 161.808594 210.472656 L 161.132812 212.09375 C 160.179688 214.386719 157.550781 215.472656 155.257812 214.523438 Z M 155.257812 214.523438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(35.686275%,80.784314%,86.666667%)",
      fillOpacity: 1
    },
    d: "M 146.746094 235.042969 L 117.804688 223 C 115.515625 222.046875 114.429688 219.414062 115.378906 217.117188 L 116.050781 215.496094 C 117.007812 213.203125 119.632812 212.117188 121.925781 213.066406 L 150.867188 225.109375 C 153.15625 226.0625 154.242188 228.695312 153.292969 230.988281 L 152.621094 232.613281 C 151.664062 234.90625 149.039062 235.992188 146.746094 235.042969 Z M 146.746094 235.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(80%,80%,80%)",
      fillOpacity: 1
    },
    d: "M 166.855469 185.6875 C 166.421875 185.6875 165.996094 185.601562 165.59375 185.4375 L 136.429688 173.632812 C 134.707031 172.929688 133.871094 170.964844 134.566406 169.238281 L 136.8125 163.675781 C 137.511719 161.945312 139.476562 161.113281 141.203125 161.8125 L 170.367188 173.617188 C 172.089844 174.320312 172.921875 176.285156 172.226562 178.011719 L 169.980469 183.574219 C 169.464844 184.847656 168.230469 185.683594 166.855469 185.6875 Z M 166.855469 185.6875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(80%,80%,80%)",
      fillOpacity: 1
    },
    d: "M 105.605469 362.625 L 0.75 362.625 C 0.335938 362.625 0 362.289062 0 361.875 C 0 361.460938 0.335938 361.125 0.75 361.125 L 105.605469 361.125 C 106.019531 361.125 106.355469 361.460938 106.355469 361.875 C 106.355469 362.289062 106.019531 362.625 105.605469 362.625 Z M 105.605469 362.625 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawAddNotesReLn36);
export default __webpack_public_path__ + "static/media/undraw_add_notes_re_ln36.0c1b37a950dc84f0c555fc94d1083b17.svg";
export { ForwardRef as ReactComponent };